import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import SearchBox from '@/components/feature/SearchBox';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import HotRanking from '@/pages/home/components/HotRanking';
import CategoryEntry from '@/pages/home/components/CategoryEntry';
import LatestNews from '@/pages/home/components/LatestNews';
import TagCloud from '@/pages/home/components/TagCloud';
import TopicCollection from '@/pages/home/components/TopicCollection';
import { getHotArticles } from '@/utils/news';

export default function Home() {
  const topNews = getHotArticles(3);
  const ranking = getHotArticles(8);

  return (
    <Layout>
      <section className="border-b border-background-200 bg-gradient-to-b from-primary-50 to-background-100">
        <div className="mx-auto max-w-page px-4 py-10 md:px-6 md:py-14">
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-1.5 text-xs font-medium text-primary-700 ring-1 ring-primary-200">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500 animate-pulse-dot"></span>
              今日热点持续更新 · 前端演示数据
            </span>
            <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
              热搜榜 · 实时热门话题与趋势资讯平台
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              汇聚社会、娱乐、科技等领域的实时热点，用清晰的分类与便捷的检索，帮你在一分钟内掌握今天大家都在关注什么。
            </p>
            <div className="mx-auto mt-6 max-w-xl">
              <SearchBox size="lg" placeholder="输入关键词，搜索你关心的热点…" />
            </div>
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-page px-4 py-8 md:px-6 md:py-10">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <HeroCarousel articles={topNews} />
          </div>

          <div className="lg:col-span-1">
            <HotRanking articles={ranking} />
          </div>
        </div>

        <div className="mt-10">
          <CategoryEntry />
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <LatestNews />
          </div>
          <div className="flex flex-col gap-6 lg:col-span-1">
            <TagCloud />
            <TopicCollection />
          </div>
        </div>

        <section className="mt-12 rounded-lg border border-background-200 bg-primary-50 p-6 md:p-8">
          <div className="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading text-lg font-bold text-foreground-900 md:text-xl">关于热搜榜</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                热搜榜是一个聚焦实时热门话题与趋势资讯的资讯平台，覆盖社会、娱乐、科技三大板块。我们希望通过清晰的分类、便捷的搜索与阅读体验，让了解热点这件事变得更简单。本站所有内容均为前端演示样例，不代表任何真实报道。
              </p>
            </div>
            <Link
              to="/about"
              className="shrink-0 whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              了解更多
            </Link>
          </div>
        </section>
      </div>
    </Layout>
  );
}